// extracted by mini-css-extract-plugin
module.exports = {"arrow":"DropdownArrow-module__arrow___gDNum","arrow_down":"DropdownArrow-module__arrow_down___1ewgm","arrow_up":"DropdownArrow-module__arrow_up___ToBSj"};